var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgOutbound = function SvgVaknlLgOutbound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D9B8B",
    fillRule: "nonzero",
    d: "M17.727 17.222 13.91 22.02l-1.666 2.092-3.971 4.999H7.091l2.222-12.102 8.355.201zm0-4.558-.059.012-8.379.201L7.091.775h1.182l3.971 4.999 1.666 2.092z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.545,
    height: 2.364,
    x: 12,
    y: 5.501,
    fill: "#F3AD05",
    fillRule: "nonzero",
    rx: 1.182
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.117 12.983-4.112.107L0 9.048h1.182z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.545,
    height: 2.364,
    x: 12,
    y: 21.91,
    fill: "#F3AD05",
    fillRule: "nonzero",
    rx: 1.182
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.129 16.789-3.947 3.935H0l1.04-4.041z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8 2.114 7.955 10.828M8 27.658l7.955-10.828"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m17.727 12.664-.059.012-8.379.201L7.091.775h1.182l3.971 4.999 1.666 2.092zm0 4.444-3.817 4.798-1.666 2.092-3.971 4.999H7.091l2.222-12.102 8.355.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D9B8B",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m0 13.113 23.636-.59A2.363 2.363 0 0 1 26 14.886h0a2.365 2.365 0 0 1-2.364 2.364L0 16.659v-3.546z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m0 13.113 23.636-.59A2.363 2.363 0 0 1 26 14.886h0a2.365 2.365 0 0 1-2.364 2.364L0 16.659v-3.546z"
  }))));
};
export default SvgVaknlLgOutbound;